import React, {FC, useEffect, useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {Button} from '../../../../_gori/partials/widgets'
import {
  BranchesMenu,
  BranchesMenuBranch,
  DEFAULT_BRANCHES,
  getSelectedAccountIds,
} from '../components/BranchesMenu'

type Props = {
  show: boolean
  handleClose: () => void
  onApply?: (branches: BranchesMenuBranch[], selectedAccountIds: Array<string | number>) => void
  initialBranches?: BranchesMenuBranch[]
}

const cloneBranches = (branches: BranchesMenuBranch[]): BranchesMenuBranch[] =>
  branches.map((branch) => ({
    ...branch,
    accounts: branch.accounts.map((account) => ({...account})),
  }))

const BranchesMenuModal: FC<Props> = ({show, handleClose, onApply, initialBranches}) => {
  const intl = useIntl()
  const [draftBranches, setDraftBranches] = useState<BranchesMenuBranch[]>(DEFAULT_BRANCHES)
  const [appliedBranches, setAppliedBranches] = useState<BranchesMenuBranch[]>(DEFAULT_BRANCHES)

  useEffect(() => {
    if (!show) {
      return
    }
    setDraftBranches(cloneBranches(initialBranches ?? appliedBranches))
  }, [appliedBranches, initialBranches, show])

  const handleCloseModal = () => {
    handleClose()
  }

  const handleCancel = () => {
    setDraftBranches(cloneBranches(initialBranches ?? appliedBranches))
    handleCloseModal()
  }

  const handleApply = () => {
    const nextBranches = cloneBranches(draftBranches)
    setAppliedBranches(nextBranches)
    onApply?.(nextBranches, getSelectedAccountIds(nextBranches))
    handleCloseModal()
  }

  return (
    <Modal
      id='gori_modal_branches_menu'
      tabIndex={-1}
      aria-hidden='true'
      dialogClassName='modal-size-md h-auto branches-menu-modal'
      contentClassName='modal-padding branches-menu-modal__content'
      show={show}
      backdrop='static'
      onHide={handleCloseModal}
    >
      <Modal.Header closeButton className='branches-menu-modal__header'>
        <Modal.Title bsPrefix='fw-bolder fs-1 modal-title'>
          {intl.formatMessage({id: 'ACCOUNTS'})}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className='branches-menu-modal__body p-0'>
        <BranchesMenu
          branches={draftBranches}
          onBranchesChange={setDraftBranches}
          showTitle={false}
          className='branches-menu--modal'
        />
      </Modal.Body>
      <Modal.Footer className='branches-menu-modal__footer'>
        <div className='d-flex w-100 gap-3'>
          <Button
            classNameDiv='w-50'
            className='btn btn-advanced-secondary flex-fill w-100'
            label={intl.formatMessage({id: 'CANCEL'})}
            loadingText={intl.formatMessage({id: 'CANCEL'})}
            event={handleCancel}
          />
          <Button
            classNameDiv='w-50'
            className='btn btn-advanced-primary flex-fill w-100'
            label={intl.formatMessage({id: 'APPLY'})}
            loadingText={intl.formatMessage({id: 'APPLY'})}
            event={handleApply}
          />
        </div>
      </Modal.Footer>
    </Modal>
  )
}

export {BranchesMenuModal}
